export default (params) => ({
  trigger: {
    name: 'search.select_typeahead',
    params: params,
  },
  config: {
    schema: {
      search_term: {
        type: 'string',
      },
      typeahead: {
        type: 'string',
      },
      index: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'previously_searched_terms',
          'interesting_for_you',
          'best_sold_products',
          'products',
          'advice',
          'default',
          'popular_search',
        ],
      },
    },
    event: {
      name: 'select_typeahead',
    },
  },
});
